import React from 'react';
import Icon from '../../../components/AppIcon';

const PersonaSection = () => {
  const personas = [
    {
      icon: 'Shield',
      title: 'Insurance Adjusters',
      description: 'Make coverage decisions and subrogation assessments with confidence',
      color: 'text-blue-600'
    },
    {
      icon: 'Scale',
      title: 'Plaintiff Attorneys',
      description: 'Evaluate case viability and develop litigation strategy efficiently',
      color: 'text-purple-600'
    },
    {
      icon: 'Gavel',
      title: 'Defense Attorneys',
      description: 'Assess exposure and determine settlement posture accurately',
      color: 'text-indigo-600'
    },
    {
      icon: 'Search',
      title: 'SIU Investigators',
      description: 'Detect fraud and arson indicators with AI-powered analysis',
      color: 'text-red-600'
    },
    {
      icon: 'DollarSign',
      title: 'Subrogation Specialists',
      description: 'Identify recovery targets and build strong subrogation cases',
      color: 'text-green-600'
    },
    {
      icon: 'AlertCircle',
      title: 'Prosecutors',
      description: 'Evaluate malice indicators and strengthen criminal cases',
      color: 'text-orange-600'
    },
    {
      icon: 'Flame',
      title: 'Fire Marshals/AHJs',
      description: 'Review code compliance observations and investigation findings',
      color: 'text-amber-600'
    },
    {
      icon: 'TrendingUp',
      title: 'Risk Managers',
      description: 'Develop prevention strategies based on comprehensive analysis',
      color: 'text-teal-600'
    },
    {
      icon: 'Home',
      title: 'Property Owners',
      description: 'Understand claim processes and make informed decisions',
      color: 'text-cyan-600'
    }
  ];

  return (
    <section className="py-16 md:py-24 lg:py-32 bg-background">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Built for Fire Forensics Professionals
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Our platform serves 9 distinct personas across the fire forensics ecosystem, each with specialized needs and workflows.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {personas?.map((persona, index) => (
            <div
              key={index}
              className="bg-card border border-border rounded-xl p-6 transition-smooth hover:shadow-elevation-md hover:-translate-y-1"
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 rounded-lg bg-muted flex items-center justify-center mb-4 ${persona?.color}`}>
                <Icon name={persona?.icon} size={24} />
              </div>
              <h3 className="text-lg md:text-xl font-semibold text-foreground mb-2">
                {persona?.title}
              </h3>
              <p className="text-sm md:text-base text-muted-foreground">
                {persona?.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PersonaSection;